import React, { useState, useEffect, useReducer } from 'react';
import { Input, Button, MaxModal, Icon, Alert } from '@maxmilhas/hangar-components-atomic/public';
import Loading from '../../../shared/create-offer/Loading/Loading';
import HangarIcon from './../atoms/HangarIcon'
import { getUserToken } from "../../shared/utils";
import jwt_decode from "jwt-decode";
import { authorizeResale, availableResale } from '../../shared/requests-api';

const skeleton = [1, 2, 3];

const BoxResaleReusingMiles = ({closeResale}) => {
  const [loading, setLoading] = useState(true);
  const [resaleData, setResaleData] = useState({});
  const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [showSubmitModal, setShowSubmitModal] = useState(false);

  const reducer = (state, {type, payload}) => {
    switch (type) {
      case 'latam':
        return {...state, latam: {name: 'Latam', status: payload}}
      
      case 'azul':
        return {...state, azul: {name: 'Azul', status: payload}}

      case 'gol':
        return {...state, gol: {name: 'Gol', status: payload}}

      case 'tap':
        return {...state, tap: {name: 'Tap', status: payload}}

      case 'internacinal':
        return {...state, internacional: {name: 'Internacional', status: payload}}

      case 'reset':
        return {}

      default:
        return {}
    }
  }

  const [state, dispatch] = useReducer(reducer, []);

  const usertToken = getUserToken();
  const { username } = jwt_decode(usertToken);

  const formatMoney = value => <strong>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)}</strong>;
  
  const getResaleData = async () => {
    setLoading(true);

    const {data} = await availableResale();

    const {status, resales} = data;

    if ((status >= 200) && (status <=299)) {
      setResaleData(resales);
      setLoading(false);
    }
  }

  const closeModal = () => {
    getResaleData();
    setShowSubmitModal(false);
    setSelectedAirlines([]);
    dispatch({type: 'reset'});
  }

  const submitAuthorization = () => {
    setShowSubmitModal(true)

    Promise.all(selectedAirlines.map(airline => {
      const { acronym, totalMiles, ratio } = airline;

      const body = {
        airline: acronym,
        total: totalMiles,
        username: username
      }

      if (acronym !== 'internacional') {
        body.ratio = ratio
      }

      dispatch({ type: acronym, payload: 'loading'})

      return authorizeResale(body)
        .then(res => dispatch({ type: acronym, payload: 'done' }))
        .catch(err => dispatch({ type: acronym, payload: 'failed' }))
    }))
  }

  useEffect(() => {
    getResaleData();
  }, []);

  const handleSelectAirline = airline => {
    const selected = [...selectedAirlines];
    const index = selectedAirlines.indexOf(airline);

    if (index === -1) {
      selected.push(airline);
    } else {
      selected.splice(index, 1);
    }

    setSelectedAirlines(selected);
  };

  const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

  const getMilesProgram = airline => {
    switch (airline) {
      case 'latam': 
        return 'Latam Pass'
      case 'azul':
        return 'TudoAzul'
      case 'gol':
        return 'Smiles'
      case 'internacional':
        return 'Todos os programas'
      case 'tap':
        return 'TAP Miles&Go'
      default:
        return ''
    }
  }

  const { availableResales, debits } = resaleData;
  const [feeDeparture] = debits || [];
  const airlineStatus = Object.values(state);

  return (
    <>
      <div className='reusing-miles'>
        <p className='reusing-miles__title'>Milhas a serem reutilizadas</p>
        <p className='reusing-miles__information'>Veja o total de milhas por companhia que será reutilizado para quitar seu débito. A quantidade de milhas do processo de reutilização será a mesma das vendas que foram canceladas.</p>

        <div className='reusing-miles__airlines'>
          {(!availableResales || loading) && (
            skeleton.map(index => (
              <span key={index} className='reusing-miles__airlines--skeleton' />
            ))
          )}

          {(availableResales && !loading) && availableResales.map(airline => (
            <div
              key={airline.acronym}
              className={`reusing-miles__airlines--card ${!airline.enabled ? 'disabled' : ''}`}
              onClick={airline.enabled 
                ? () => handleSelectAirline(airline)
                : () => {}}
            >
              <Input
                type='checkbox'
                id={airline.acronym}
                value={airline.acronym}
                checked={selectedAirlines.indexOf(airline) !== -1}
                label=" "
              />

              <div className='reusing-miles__airlines--card__content'>
                <div className='reusing-miles__airlines--card__title-wrapper'>
                  <h5>
                    {capitalize(airline.acronym)}
                  </h5>

                  <p className="reusing-miles__airlines--card__subtitle">{getMilesProgram(airline.acronym)}</p>
                </div>

                <div>
                  <div>
                    <h3>{`${airline.totalMiles}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h3>
                    <p>Milhas</p>
                  </div>

                  {(airline.enabled && airline.ratio) && (
                    <div>
                      <h6>{`${airline.ratio}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h6>
                      <p>Média por passageiro</p>
                    </div>
                  )}

                  {!airline.enabled && (
                    <div className='reusing-miles__airlines--card__badge-wrapper' >
                      <div className='reusing-miles__airlines--card__badge'>
                        Indisponível
                      </div>

                      <div className='reusing-miles__doubt'>
                        <HangarIcon tooltip="Essas milhas não podem ser reutilizadas e devem ser pagas por cartão de crédito" icon="icon-max-communication-doubt" />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {debits && debits.length > 0 && <div className='reusing-miles__warning'>
            <p>Atenção! Ainda restará um débito de {formatMoney(feeDeparture.amount)} referente às taxas de embarques pagas por você. Esse valor deve ser quitado por cartão de crédito depois que você autorizar a reutilização das milhas, combinado?</p>
          </div>}
      </div>

      <div className="resale-form__buttons">
        <div className="resale-form__buttons resale-form__buttons--back">
          <Button
            outline={true}
            color="#1abc9c"
            onClick={() => closeResale(false)}
            size="normal"
            type="button"
          >
            Voltar
          </Button>
        </div>

        <div className="resale-form__buttons resale-form__buttons--confirm">
          <Button
            color="green"
            onClick={submitAuthorization}
            disabled={selectedAirlines.length < 1 || loading}
            size="normal"
            type="button"
          >
            Autorizar reutilização
          </Button>
        </div>
      </div>

      <MaxModal open={showSubmitModal} showCloseIcon={false}>
        <div className="max-modal">
            <h5>Reutilização das milhas</h5>

            <p>As milhas em reutilização serão cadastradas em uma nova oferta. Por isso, se você tem uma oferta ativa do mesmo programa de fidelidade, ela será substituída até que todas as milhas sejam reutilizadas em novas emissões.</p>

          <ul className="max-modal__list">
            {airlineStatus.map(item => {
                return (
                  <li className="max-modal__item">
                    <span className="max-modal__label">{item.name}</span>

                    <div className="max-modal__text-wrap">
                      <span className="max-modal__text">
                        {item.status === 'done' && 'Oferta criada'}
                        {item.status === 'failed' && 'Tente novamente'}
                      </span>
                      {item.status === 'loading' && <Loading width="25" heigth="25" />}
                      {item.status === 'done' && <Icon name="icon-max-communication-circle-check" size="small" color="#1abc9c" />}
                      {item.status === 'failed' && <Icon name="icon-max-communication-attention" size="small" color="#ffb907" />}
                    </div>
                  </li>
                )
              })}
            </ul>
            <Button
              color="green"
              onClick={closeModal}
              size="normal"
              type="button"
            >
              Ok, entendi!
            </Button>
          </div>
      </MaxModal>
    </>
  );
};

export default BoxResaleReusingMiles;
